import React from 'react';
import PropTypes from 'prop-types';

const IconText = ({
  iconSrc, text, iconStyle, textStyle, containerStyle
}) => (
  <view style={{ ...defaultStyles.container, ...containerStyle }}>
    <image src={iconSrc} style={{ ...defaultStyles.icon, ...iconStyle }} />
    <text style={{ ...defaultStyles.text, ...textStyle }} content={text} />
  </view>
);

const defaultStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    display: 'inline-block',
    width: 12,
    height: 12,
    marginRight: 2, // Adjust spacing between icon and text
  },
  text: {
    fontSize: '12', // Adjust text size
    color: '#4D4D4D',
  },
};

IconText.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  iconStyle: PropTypes.object,
  textStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

IconText.defaultProps = {
  iconStyle: {},
  textStyle: {},
  containerStyle: {},
};

export default IconText;
